import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Empty, PageHeader } from "@/components/kit";
import ExercisesTab from "@/components/exercises/ExercisesTab";

export default function Library() {
  return (
    <div>
      <PageHeader eyebrow="Reusable resources" title="Library" testid="library-title" />
      <Tabs defaultValue="exercises">
        <TabsList className="mb-6 h-auto flex-wrap border border-[#1E293B] bg-[#111827]">
          <TabsTrigger value="exercises" data-testid="library-tab-exercises">Exercise library</TabsTrigger>
          <TabsTrigger value="meals" data-testid="library-tab-meals">Meal library</TabsTrigger>
        </TabsList>
        <TabsContent value="exercises"><ExercisesTab /></TabsContent>
        <TabsContent value="meals"><Empty text="No food items yet." /></TabsContent>
      </Tabs>
    </div>
  );
}
